

import { Toaster } from "components";

import ic_email from 'assets/images/ic_send_email.svg';
import ic_delete from 'assets/images/ic_delete_invoices.svg';

import { func_validation, func_file, isArrayNotEmpty, deepCloneArray } from 'functions';
import React, { useEffect, useState } from 'react';
import { ConfirmationModal } from 'components/modals/ConfirmationModal';
import { FormInput_text } from 'components/form/formInput/FormInput_text';
import { Datepicker } from 'components/form/Datepicker';



export function useUnpostedDebitNote(props) {
    const {
        selectedDebitNotes,
        totalRequests,
        postDebitNote_requesting
    } = props;

    const [isModalVisible, setIsModalVisible] = useState();
    const [debitNoteId, setDebitNoteId] = useState();
    const [accountCode, setAccountCode] = useState();
    const [chargeMonth, setChargeMonth] = useState();
    const [postingDebitNotes, setPostingDebitNotes] = useState([]);

    function postDebitNote() {
        if (func_validation.isFunction(props.setAlertMsg)) props.setAlertMsg([]);

        if (func_validation.isArrayNotEmpty(selectedDebitNotes)) {
            setPostingDebitNotes(selectedDebitNotes);
        }
        else if ((func_validation.isStringTrimNotEmpty(accountCode) ||
            func_validation.isStringTrimNotEmpty(chargeMonth) ||
            func_validation.isNumberOrStringValid(debitNoteId)) &&
            func_validation.isFunction(props.postDebitNote)) {

            props.postDebitNote(debitNoteId, chargeMonth, accountCode);
        }
    }
    useEffect(() => {
        if (!totalRequests &&
            isArrayNotEmpty(postingDebitNotes)) {

            let id = postingDebitNotes[0]?.Id;
            let accountCode = postingDebitNotes[0]?.AccountCode;
            let chargeMonth = postingDebitNotes[0]?.ChargeMonth;

            if (func_validation.isNumberValid(id) &&
                func_validation.isStringTrimNotEmpty(accountCode) &&
                func_validation.isStringTrimNotEmpty(chargeMonth) &&
                func_validation.isFunction(props.postDebitNote)) {

                props.postDebitNote(id, chargeMonth, accountCode);
                let newList = deepCloneArray(postingDebitNotes);
                newList.splice(0, 1);
                setPostingDebitNotes(newList);
            }
        }
    }, [totalRequests, JSON.stringify(postingDebitNotes)]);


    let tableActions = [
        {
            icon: ic_delete,
            label: "Delete",
            isDisabled: func_validation.isUserAccessDenied(props, "Internal_AdvancePay_Delete"),
            onClick: () => {
                if (func_validation.isArrayNotEmpty(selectedDebitNotes)) {
                    if (func_validation.isFunction(props.setIsDeleteModalVisible))
                        props.setIsDeleteModalVisible(true);

                    if (func_validation.isFunction(props.setSelectedDebitNotes))
                        props.setSelectedDebitNotes(selectedDebitNotes);
                }
                else {
                    Toaster({
                        type: "info",
                        msg: "Please select at least 1 debit note.",
                    });
                }
            },
        }
    ];

    let filters = {
        postStatus: "unposted",
    }
    let tabDetails = {
        id: "unposted",
        text: "Unposted",
        filters
    };

    let mainTableActionDetails = {
        onClick: () => setIsModalVisible(true),
        isDisabled: func_validation.isUserAccessDenied(props, "Internal_SqlAccount_Post"),
        icon: ic_email,
        alt: "Mail Icon"
    };

    useEffect(() => {
        setAccountCode("");
        setChargeMonth("");
    }, [isModalVisible]);

    let postDebitNoteModal = (
        <ConfirmationModal
            description={"Posting Debit Note(s)"}
            className={"debit-note__post-debit-note"}
            input={(!func_validation.isArrayNotEmpty(selectedDebitNotes)) ? (
                <div className={"post-debit-note__inputs"}>
                    {/* Debit Note ID */}
                    <FormInput_text
                        inputLabel={"Debit Note ID"}

                        className={"post-debit-note__debit-note-id"}
                        inputValue_default={debitNoteId}

                        isInputBlurHandlingRequired
                        handleInputBlurExtend={(value) => { setDebitNoteId(value); }}

                        inputMaxLength={64}

                        isInputValueTrim_onChange
                        isMarginBtmOptional isInputDigitOnly isConvertedToNumber
                        isInputOptional
                    />

                    {/* Account Code */}
                    <FormInput_text
                        inputLabel={"Account Code"}

                        className={"post-debit-note__account-code"}
                        inputValue_default={accountCode}

                        isInputBlurHandlingRequired
                        handleInputBlurExtend={(value) => { setAccountCode(value); }}

                        isInputValueTrim_onChange
                        isMarginBtmOptional
                        isInputOptional
                    />

                    {/* Charge Month */}
                    <Datepicker
                        className={"post-debit-note__charge-month"}
                        inputClassName={"charge-month__input"}

                        label={"Charge Month"}
                        dateFromParent={chargeMonth}
                        defaultDate={chargeMonth}
                        isResetRequired={isModalVisible}
                        handleOnChange={setChargeMonth}

                        dateFormat={"MM/yyyy"}

                        isConversionRequired_ISO8601 isMonthYear
                    />
                </div>
            ) : ""}

            cancelButtonText={"Cancel"}
            confirmButtonText={"Confirm"}
            isModalVisible={isModalVisible}
            updateParentState={setIsModalVisible}
            handleOnConfirm={postDebitNote}
            isActionLoading={postDebitNote_requesting}
            isConfirmSuccessful={totalRequests == 0}
        />
    );

    return {
        tableActions,
        mainTableActionDetails,
        tabDetails,
        filters,

        isModalVisible, setIsModalVisible,
        postDebitNoteModal,

        postDebitNote
    }
}